import PostCard, { PostCardVariant } from "@/ui/PostCard/PostCard";
import { AlgoliaPost } from "@repo/algolia/types";
import styles from "./PostsMosaic.module.scss";
import clsx from "clsx";
import { POSTS_PREVIEW_QUERY_RESULT } from "@/types/sanity.types";
import { match } from "ts-pattern";

type Props = {
  posts: AlgoliaPost[] | POSTS_PREVIEW_QUERY_RESULT;
  variant:
    | "3-columns-wide"
    | "3-columns"
    | "2-columns-wide"
    | "4-columns+2-columns-wide";
  darkMode?: boolean;
};

const PostsMosaic: React.FC<Props> = ({ posts, variant, darkMode = false }) => {
  const [variantStyle, cardVariant] = match(variant)
    .returnType<[string, PostCardVariant]>()
    .with("3-columns", () => [styles.columns3, "vertical"])
    .with("3-columns-wide", () => [styles.columns3Wide, "horizontal"])
    .with("2-columns-wide", () => [styles.columns2Wide, "horizontal"])
    .with("4-columns+2-columns-wide", () => [styles.columns42Wide, "auto"])
    .exhaustive();

  return (
    <ol className={clsx(styles.list, variantStyle)}>
      {posts.map((post) => {
        const id = "objectID" in post ? post.objectID : post._id;
        return (
          <li key={id} className={styles.item}>
            <PostCard post={post} variant={cardVariant} darkMode={darkMode} />
          </li>
        );
      })}
    </ol>
  );
};

export default PostsMosaic;
